// extracted by mini-css-extract-plugin
export default {"draggableChoice":"draggableChoice__nuwFv","transparentBackground":"transparentBackground__Qx9gE","content":"content__AS3fY","rectangle":"rectangle__WOOQV","circle":"circle__b9Eeh"};